import { Pipe, PipeTransform } from '@angular/core';
import { ItemForDisplay } from '../../models';

@Pipe({
  name: 'addToCartIcon',
  standalone: true,
  pure: true,
})
export class AddToCartIconPipe implements PipeTransform {
  transform(item: ItemForDisplay): string {
    return item.HidePrice ? '' : 'pi pi-shopping-cart';
  }
}
